/* ---------------------------------
  animation
--------------------------------- */

AOS.init({
  duration: 400,
  offset: 40,
  easing: 'ease-in',
  delay: 100,
  // once: true,
  // disable: 'mobile',
});


/* ---------------------------------
 ページ内スクロール
--------------------------------- */

var pagelink = 65;

$(window).on('load resize', function(){
    if (!window.matchMedia("(max-width:750px)").matches) {
        //PC表示の設定
        pagelink = 100;
    } else {
        //スマホ表示の設定
        pagelink = 65;
    }
});


$(function() {
    
      //URLのハッシュ値を取得
      var urlHash = location.hash;
      //ハッシュ値があればページ内スクロール
      if(urlHash) {
        //スクロールを0に戻す
        $('body,html').stop().scrollTop(0);
        setTimeout(function () {
          //ロード時の処理を待ち、時間差でスクロール実行
          scrollToAnker(urlHash) ;
        }, 400);
      }

      //通常のクリック時
      $('a[href^="#"].scroll').click(function() {
        //ページ内リンク先を取得
        var href= $(this).attr("href");
        //リンク先が#か空だったらhtmlに
        var hash = href == "#" || href == "" ? 'html' : href;
        //スクロール実行
        scrollToAnker(hash);
        //リンク無効化
        return false;
      });

      // 関数：スムーススクロール
      // 指定したアンカー(#ID)へアニメーションでスクロール
      function scrollToAnker(hash) {
        var target = $(hash);
        var position = target.offset().top;
        $('body,html').stop().animate({scrollTop:position  - pagelink }, 600);
      }
    
 });   

  
/* ---------------------------------
  SP NAVI
--------------------------------- */
(function(){
  var spNav = function(){
    var $winWidth = $(window).width();
    var $winHeight = $(window).height();
    var $navBk = $('#sp_menuBk');
    var $nav = $('#g-menu');
    var $openBtn = $('#sp_menu');
    var $closeBtn = $('#sp_menu_close');

    $openBtn.on('click', function(){
      $navBk.fadeIn();
      $nav.fadeIn();
      $openBtn.fadeToggle();
      $closeBtn.fadeToggle();
    });
      
      
    var CloseTrigger = function(el){
      el.on('click', function(){
        $nav.fadeOut();
        $openBtn.fadeToggle();
        $closeBtn.fadeToggle();
        $navBk.fadeOut();
      });
    };
    var closeTriggerBtn = new CloseTrigger($closeBtn);
    var closeTriggerBk = new CloseTrigger($navBk);

    $(window).on('load resize', function(){
      var $winWidth = $(window).width();
      var $docHeight = $(document).height();
      if($winWidth > 750){
        setTimeout(function(){
          $nav.hide();
          $openBtn.show();
          $closeBtn.hide();
          $navBk.hide();
        },200);

      }else{
        $('#g-menu a').on('click', function(){
            $nav.stop().fadeOut();
            $openBtn.stop().fadeToggle();
            $closeBtn.stop().fadeToggle();
            $navBk.stop().fadeOut();
        });
      }
    });

  }();

})();
